<div class="plan-details-component-container mat-typography mat-body">
  <!-- Benefit Grid-->
  @if (plans) {
    <section class="benefit-grid">
      @if (plans) {
        <app-benefit-grid [plans]="plans" [market]="market"></app-benefit-grid>
      }
      @if (plansFullData?.length === 1 && isIndividualMarket) {
        <app-additional-plan-links [planData]="plansFullData[0]"></app-additional-plan-links>
      }
    </section>
  }
</div>
